import { render } from "./VisitorNameHeader.vue?vue&type=template&id=a376b390"
import script from "./VisitorNameHeader.vue?vue&type=script&lang=js"
export * from "./VisitorNameHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__